export const rolesConstants = {
  ROLE_CUSTOMER: 'ROLE_CUSTOMER',
  ROLE_COMMERCIAL: 'ROLE_COMMERCIAL',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
};
